import {gsap} from "gsap";

class ModulePreloader {
  init() {}

  hidePreloaderLogo = () => {
    gsap.to('.preloader_logo',
      {
      rotate: -10,
      duration: .4,
      repeat: 0,
      autoAlpha: 0,
      scale: .0
    });
  }

  hidePreloader = () => {
    gsap.fromTo('.preloader',
    {
      rotate: 0,
      scale: 1
    },
    {
      rotate: 0,
      duration: 1.5,
      repeat: 0,
      ease: "expo.out",
      scale: 1.2,
      y: '120%',
      x: 0,
      delay: 0
    });
  }
}

export default ModulePreloader;
